
export default function NigeriaSection() {
  return (
    <section className="py-20 bg-stone-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-800 mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
            Built for Nigeria. Designed to Scale.
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            The Monthly Millionaire Project operates nationwide across Nigeria, with a structured support system designed to help you succeed regardless of your location. Our headquarters in Lagos serves as the hub for training, mentorship, and business development.
          </p>
        </div>
      </div>
    </section>
  );
}
